module.exports = __webpack_public_path__ + "static/media/error.7b9c84e8.svg";